import type { GetCampaignParams } from "@onhandtech/onhand-fe-shared/lib/contracts/api/v5/campaign/campaign";
import type { GetRequestFilterSetParams } from "@onhandtech/onhand-fe-shared/lib/contracts/api/v5/request-filter-set/request-filter-set";

export enum ContentPublishStatus {
	PUBLIC = "public",
	TARGETED = "targeted",
	UNPUBLISHED = "unpublished",
}

export type ContentPublishStatusParams =
	| GetRequestFilterSetParams
	| GetCampaignParams;

export type ContentStatusHookReturn<ClientResponse> = {
	makeGetRequest: (type?: ContentPublishStatus) => void;
	getSegmentedData: (type?: ContentPublishStatus) => ClientResponse | null;
	loading: boolean;
};

export type ContentStatusHook<T> = () => ContentStatusHookReturn<T>;
